// extracted by mini-css-extract-plugin
export var brand = "_9a-9";
export var compact = "_9a-6";
export var extraSmall = "_9a-7";
export var icon = "_9a-0";
export var large = "_9a-4";
export var light = "_9a-1";
export var medium = "_9a-5";
export var outline = "_9a-b";
export var primaryDark = "_9a-a";
export var primaryLight = "_9a-8";
export var primaryModern = "_9a-c";
export var success = "_9a-2";
export var successSolid = "_9a-3";